import BundlesView from 'views/BundleOffersView'
import Page from 'components/Page'
import { useRequiresGuestLogin } from 'hooks/useRequiresLogin'

const BundlesPage = () => {
  useRequiresGuestLogin()
  return <Page
    title='All Bundles'
    width='wide'
  >
    <BundlesView />
  </Page>
}

export default BundlesPage
